import clsx from "clsx";
import { useIsDocsAndExtractActive } from "core/model/careseekers";
import { Button } from "ds/ui";
import { SparklesIcon } from "lucide-react";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { useTranslations } from "translations";
import { DocsFormDataMapped, DocsFormName } from "./Forms";

export const SourceWrapper = <T extends DocsFormName = DocsFormName>({
  children,
  fieldName,
  hideSource,
  isIconOnly,
  setSourceSelected,
  sourceSelected,
}: {
  children: ReactNode;
  sourceSelected: keyof DocsFormDataMapped<T> | undefined;
  setSourceSelected: Dispatch<
    SetStateAction<keyof DocsFormDataMapped<T> | undefined>
  >;
  fieldName: keyof DocsFormDataMapped<T>;
  isIconOnly?: boolean;
  hideSource?: boolean;
}) => {
  const { isDocsAndExtractActive } = useIsDocsAndExtractActive();
  const translations = useTranslations();
  if (!children) {
    return null;
  }

  if (!isDocsAndExtractActive || hideSource) {
    return <div className="p-4">{children}</div>;
  }

  const isSelected = sourceSelected === fieldName;

  return (
    <div
      className={clsx("flex w-full rounded-md p-4", {
        "bg-blue-50": isSelected,
        "bg-white": !isSelected,
      })}
    >
      <div
        className={clsx("flex items-center justify-between", {
          "w-[70%]": !isIconOnly,
          "w-[85%]": isIconOnly,
        })}
      >
        {children}
      </div>
      <div
        className={clsx("flex items-center justify-end", {
          "w-[15%]": isIconOnly,
          "w-[30%]": !isIconOnly,
        })}
      >
        <Button
          aria-label={translations.fileSection.fileListComponent.source}
          color="primary"
          endContent={<SparklesIcon />}
          id={`source-button-${String(fieldName)}`}
          isIconOnly={isIconOnly}
          variant="light"
          onPress={() => setSourceSelected(fieldName)}
        >
          {isIconOnly
            ? null
            : translations.fileSection.fileListComponent.source}
        </Button>
      </div>
    </div>
  );
};
